import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Container from '@components/ui/Container/Container'

import { FC } from 'react'
import styles from './RichText.module.scss'

export type RichTextProps = {
  richText?: string
  maxWidth?: number
  fitContent?: 'Min-Content' | undefined
  position?: 'Left' | 'Center' | 'Right' | undefined
  backgroundColor?: string
  backgroundColor1?: string
  container?: boolean
  paddingTop?: number
  paddingBottom?: number
  paddingLeft?: number
  paddingRight?: number
  textDefaultColor?: string
}

const RichText: FC<RichTextProps> = ({
  richText,
  maxWidth,
  fitContent,
  position,
  backgroundColor,
  backgroundColor1,
  textDefaultColor,
  container,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
}) => {
  const bgHex = backgroundColor ?? `#${backgroundColor1}`

  const content = (
    <div
      style={{
        width:
          removeWhitespaces(fitContent) ??
          `${maxWidth == 0 ? 100 : maxWidth}vw`,
        paddingLeft: paddingLeft ? `${paddingLeft}vw` : undefined,
        paddingTop: paddingTop ? `${paddingTop}vw` : undefined,
        paddingRight: paddingRight ? `${paddingRight}vw` : undefined,
        paddingBottom: paddingBottom ? `${paddingBottom}vw` : undefined,
        color: textDefaultColor || undefined,
        backgroundColor: bgHex || undefined,
        margin: position
          ? `${
              position == 'Center'
                ? '0 auto'
                : position == 'Right'
                  ? '0 0 0 auto'
                  : '0 auto 0 0'
            }`
          : `0 auto`,
      }}
      className={styles.richText}
    >
      <TrustedHtml html={richText} />
    </div>
  )

  return container ? (
    <Container backgroundColor={bgHex}>{content}</Container>
  ) : (
    content
  )
}

const removeWhitespaces = (str?: string) => {
  if (str == undefined || str.trim() == '') return null
  return str
}

export default RichText
